import React from "react";
import LinearProgress from "@mui/material/LinearProgress";
import { useAuth } from "@homesusa/auth";
import { UserPanel } from "../components";
import { UserProvider } from "../providers";

function UserProfile(): JSX.Element {
  const { user } = useAuth();
  if (!user) {
    return <LinearProgress />;
  }
  return (
    <UserProvider userId={user.id}>
      <UserPanel />
    </UserProvider>
  );
}

export default UserProfile;
